import { DocumentsCurrencyInfo } from "../types";
import { formatToDecimal } from "./format-to-decimal";

export const updateCurrencyInfo = (
  acc: DocumentsCurrencyInfo,
  currency: string,
  amount: number
) => {
  if (!acc[currency]) {
    acc[currency] = { sum: 0, count: 0 };
  }

  acc[currency].sum = formatToDecimal(acc[currency].sum + amount);
  acc[currency].count++;
};
